import { Box, Container, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { WsColors } from 'wisestep-base';

import { useWorkspaceContext } from '../../context';
import NavBar from '../NavBar';
import SideBar from '../SideBar';

type LayoutProps = {
  children: React.ReactNode;
};

const AppLayout = ({ children }: LayoutProps) => {
  const [openSideBar, setOpenSideBar] = useState(false);
  const navigate = useNavigate();

  const workspaceContext = useWorkspaceContext();

  const handleMenuOpen = () => setOpenSideBar(true);
  const handleMenuClose = () => setOpenSideBar(false);

  const StyledBox = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  }));

  const StyledSidebarGrid = styled(Grid)({
    backgroundColor: WsColors.White,
  });

  useEffect(() => {
    const url = window.location.origin.split('.');
    if (
      url[0].split('//')[1] === workspaceContext.link &&
      workspaceContext['onBoardingQuestionAnswered'] === false &&
      workspaceContext.owns === true
    ) {
      navigate('/onboarding');
    }
  }, [navigate, workspaceContext]);

  return (
    <>
      <NavBar sideMenuOpen={handleMenuOpen} />
      <Grid container component="main" sx={{ height: '100vh' }}>
        <StyledSidebarGrid item xs={0.6}>
          <SideBar open={openSideBar} sideMenuClose={handleMenuClose} />
        </StyledSidebarGrid>
        <Grid item xs>
          <Container component="main" maxWidth="xl">
            <StyledBox>{children}</StyledBox>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default AppLayout;
